import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type NoFilesInFolderProps = {
  primaryAction: ReactNode;
};

export const NoFilesInFolder = ({ primaryAction }: NoFilesInFolderProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="knowledge_base.empty_state.no_files.title" />
        }
        message={
          <FormattedMessage id="knowledge_base.empty_state.no_files.message" />
        }
        primaryCTA={primaryAction}
      />
    </EmptyStateContainer>
  );
};
